/* unplugin-vue-components disabled */import { render } from "./GuidePage.vue?vue&type=template&id=3b9ec944&scoped=true"
import script from "./GuidePage.vue?vue&type=script&lang=js"
export * from "./GuidePage.vue?vue&type=script&lang=js"

import "./GuidePage.vue?vue&type=style&index=0&id=3b9ec944&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9ec944"]])

export default __exports__